import { CapacitorCookies } from '@capacitor/core';
import { isCordova } from 'utils/platform';

const AUTH_DOMAINS = [
  'https://test.withlocals.com',
  'https://www.withlocals.com',
  URL_AUTHENTICATION_HOST,
];

// TODO: The app shouldn't be responsible for clearing cookies - the server's
// Set-Cookie with Max-Age=0 should handle this. This is a workaround for
// InAppBrowser/WebView cookie store separation.
const AUTH_COOKIES = [
  '__Secure-better-auth.session_token',
  '__Secure-better-auth.state',
  '__Secure-test-better-auth.session_token',
  '__Secure-test-better-auth.state',
  'better-auth.session_token',
  'better-auth.state',
  '__Secure-next-auth.session-token',
  '__Secure-next-auth.pkce.code_verifier',
  '__Secure-next-auth.state',
  '__Secure-next-auth.nonce',
  '__Secure-next-auth.csrf-token',
  '__Secure-next-auth.callback-url',
  'dev-next-auth.session-token',
  'dev-next-auth.pkce.code_verifier',
  'dev-next-auth.state',
  'dev-next-auth.nonce',
  'dev-next-auth.csrf-token',
  'dev-next-auth.callback-url',
  'PLAY_SESSION',
];

export async function clearAuthCookies(): Promise<void> {
  if (!isCordova()) return;

  for (const url of AUTH_DOMAINS) {
    for (const key of AUTH_COOKIES) {
      try {
        await CapacitorCookies.deleteCookie({ url, key });
      } catch {
        // Ignore - cookie may not exist
      }
    }
  }
}
